var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "SummerButton",

    getDefaultProps () {
        return {"width":"48px","height":"48px","viewBox":"0 0 48 48","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>Summer_Button</title>
  <desc>Created with Sketch.</desc>
  <defs/>
  <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="Summer_Button" fill="#034C8C">
      <path d="M0,24 C0,10.745166 10.7422516,0 24,0 C37.254834,0 48,10.7422516 48,24 C48,37.254834 37.2577484,48 24,48 C10.745166,48 0,37.2577484 0,24 Z M24.0044621,12 C17.3765052,12 12,17.3762097 12,24.0066376 C12,30.6327539 17.3765052,36 24.0044621,36 C30.6279569,36 36,30.6327539 36,24.0022125 C36,17.3762097 30.6279569,12 24.0044621,12 Z M24.0044621,13 C30.075126,13 35,17.9279482 35,24.0022125 C35,30.0784318 30.0777098,35 24.0044621,35 C17.9270453,35 13,30.0787259 13,24.0066376 C13,17.9289088 17.9283757,13 24.0044621,13 Z M16,24.0044251 C16,28.4218359 19.5843368,32 24.0029747,32 C28.4186379,32 32,28.4218359 32,24.001475 C32,19.5841398 28.4186379,16 24.0029747,16 C19.5843368,16 16,19.5841398 16,24.0044251 Z M17,24.0044251 C17,20.1366927 20.1363535,17 24.0029747,17 C27.8659425,17 31,20.1360138 31,24.001475 C31,27.868182 27.8677225,31 24.0029747,31 C20.1353711,31 17,27.8683015 17,24.0044251 Z M20,24.0022125 C20,26.210918 21.7921684,28 24.0014874,28 C26.209319,28 28,26.210918 28,24.0007375 C28,21.7920699 26.209319,20 24.0014874,20 C21.7921684,20 20,21.7920699 20,24.0022125 Z" id="Combined-Shape"/>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/images/Summer_Button.svg